export default __webpack_public_path__ + "static/media/2.d4f138a8.png";